import {
    getSessionStorageItem,
    removeSessionStorageItem,
    setSessionStorageItem,
} from "@accurx/shared/dist/sessionStorageHelper";

import { Values } from "../../../shared/types/utils.types";
import { useCurrentUser } from "../useCurrentUser";

export const LOGIN_METHODS = {
    NhsSso: "NhsSingleSignOn",
    Email: "Email",
    Passwordless: "Passwordless",
} as const;

export const LOGIN_METHOD_KEY = "loginMethod";

export type LoginMethod = Values<typeof LOGIN_METHODS>;

export const useLoginMethod = (): LoginMethod => {
    const { user } = useCurrentUser();

    if (user.isAuthenticatedExternally) {
        return LOGIN_METHODS.NhsSso;
    }

    if (
        getSessionStorageItem(LOGIN_METHOD_KEY) === LOGIN_METHODS.Passwordless
    ) {
        return LOGIN_METHODS.Passwordless;
    }

    return LOGIN_METHODS.Email;
};

export const storePasswordlessAsLoginMethod = () =>
    setSessionStorageItem(LOGIN_METHOD_KEY, LOGIN_METHODS.Passwordless);

export const clearLoginMethod = () =>
    removeSessionStorageItem(LOGIN_METHOD_KEY);
